/**
 * Build a tree from flat group post replies using parent_id.
 */
export function nestGroupReplies(flatReplies) {
  if (!Array.isArray(flatReplies) || flatReplies.length === 0) {
    return [];
  }

  const byId = {};
  const roots = [];

  flatReplies.forEach((reply) => {
    const id = String(reply.id);
    byId[id] = { ...reply, children: [] };
  });

  flatReplies.forEach((reply) => {
    const id = String(reply.id);
    const node = byId[id];
    const rawParent = reply.parent_id ?? reply.parent_reply_id;
    const parentId =
      rawParent != null && rawParent !== '' ? String(Number(rawParent)) : '';

    if (parentId && parentId !== '0' && parentId !== 'NaN' && byId[parentId] && parentId !== id) {
      byId[parentId].children.push(node);
    } else {
      roots.push(node);
    }
  });

  return roots;
}

/**
 * Past this depth, deeper post replies stop indenting so cards keep a usable width.
 */
export const MAX_REPLY_INDENT = 3;

/**
 * Direct replies to a post reply, from the post's flat replies list.
 */
export function getChildReplies(flatReplies, parentReplyId) {
  if (!Array.isArray(flatReplies)) {
    return [];
  }
  return flatReplies.filter(
    (reply) => Number(reply.parent_reply_id) === Number(parentReplyId)
  );
}
